import { CSSProperties, useState } from "react";
import IconButton from "../../elements/IconButton";

interface Props {
  text: string;
  color?: string;
  tooltipText?: string;
  successTooltipText?: string;
  style?: CSSProperties;
  iconStyle?: CSSProperties;
  hideTooltip?: boolean;
}

const AppCopy = ({
  text,
  color = "primary",
  tooltipText = "Copy",
  successTooltipText = "Copied text!",
  style,
  iconStyle,
  hideTooltip = false,
}: Props) => {
  const [copied, setCopied] = useState(false);

  return (
    <IconButton
      tooltipText={
        hideTooltip ? undefined : copied ? successTooltipText : tooltipText
      }
      onClick={handleCopy}
      icon={copied ? "mdi mdi-check-bold" : "mdi mdi-content-copy"}
      outline
      color={color}
      size="sm"
      style={style}
      iconStyle={iconStyle}
    />
  );

  function handleCopy() {
    if (!text || copied) return;

    navigator.clipboard.writeText(text);

    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  }
};

export default AppCopy;
